import React from "react";

import Heading from "./Heading";
import ContentSection from "./ContentSection";
import Footer from "./Footer";
import styled from "styled-components";
import { Divider } from "@material-ui/core";

// import "../home.css";

const Page = styled.div`
//   height: calc(100vh - 185px);
`;

const Content = styled.div`
  height: 100%;
  width: 100%;

  @media screen {
    overflow: auto;
  }
`;
const Description = styled.div`
  margin: 20px 20px 40px 20px;
`;

const Header = styled.div`
  font-size: 34px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 50px;
`;

const AboutUs = (props) => {
  return (
    <div>
      <Heading {...props} />
      <Page>
        <Content>
          <ContentSection minHeight={0}>
            <div>
              <Header>Questions, Concerns, Feedback</Header>
              <Description>
                <p>
                  If you have any questions or concerns, we can be reached via
                  email at{" "}
                  <a href="mailto:questions@roboppa.com">
                    questions@roboppa.com
                  </a>
                  .
                </p>
              </Description>
            </div>
          </ContentSection>
          <Divider />
          <ContentSection minHeight={0}>
            <div>
              <Header>Customer Support</Header>
              <Description>
                <p>
                  If you encounter any errors or have issues loading or using
                  the RoboPPA™ application, please email{" "}
                  <a href="mailto:support@roboppa.com">support@roboppa.com</a>{" "}
                  and provide the details. We will do our best to assist you in
                  a timely manner.
                </p>
              </Description>
            </div>
          </ContentSection>
          <Divider />
        </Content>
      </Page>
      <Footer />
    </div>
  );
};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/home/components/ContactUs.js